import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";

import backIcon from "../../images/back-icon.svg";
import closeIcon from "../../images/close-icon.svg";
import saveIcon from "../../images/check-icon.svg";
import notificationIcon from "../../images/notification-icon.svg";
import { BREAKPOINTS, media } from "../constants";

export const FooterLink = styled(NavLink)`
  label: footer-link;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 500;
  text-decoration: none;
  padding: 5px;
  color: ${({ theme }) => theme.palette.text.gray};

  &.active {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  img {
    height: ${({ $iscentral }) => ($iscentral ? "48px" : "20px")};
    width: ${({ $iscentral }) => ($iscentral ? "48px" : "20px")};
    margin-bottom: ${({ $iscentral }) => ($iscentral ? "4px" : "0")};
    transition: transform 0.2s ease;
  }

  ${media.min(BREAKPOINTS.tabletMin)} {
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 14px;
    gap: 10px;
    color: ${({ theme }) => theme.custom.white};
    padding: 10px 30px;

    img {
      height: 28px;
      width: 28px;
    }

    &.active {
      color: ${({ theme }) => theme.palette.primary.main};
      background-color: ${({ theme }) => theme.palette.background.gray};
    }
  }
`;

export const ExitLink = styled.a`
  label: exit-link;
  display: flex;
  padding: 10px 30px;
  width: 100%;
  height: auto;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  border: none;
  color: ${({ theme }) => theme.custom.white};
  background-color: transparent;
  gap: 10px;
  cursor: pointer;
`;

export const HeaderIcons = styled.div`
  label: header-icons;
  width: ${(props) => props.width || "18px"};
  height: ${(props) => props.width || "16px"};
  background-image: ${(props) =>
    props.backIcon
      ? `url(${backIcon})`
      : props.closeIcon
      ? `url(${closeIcon})`
      : props.notificationIcon
      ? `url(${notificationIcon})`
      : props.saveIcon
      ? `url(${saveIcon})`
      : "none"};
  background-repeat: no-repeat;
  background-position: ${(props) =>
    props.backIcon ? `left top` : props.closeIcon ? `right top` : "center top"};
  background-size: contain;
  align-items: center;
  display: flex;
  z-index: 100;
  justify-content: ${(props) => props.justify || ""};

  span {
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 600;
    margin-left: -20px;
    font-size: 18px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const AroundHeaderIcons = styled.div`
  label: around-header-icons;
  width: ${(props) => props.width || "28px"};
  height: ${(props) => props.height || "28px"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const MainHeaderIcons = styled.div`
  label: main-header-icons;
  width: ${(props) => props.width || "36px"};
  height: ${(props) => props.width || "36px"};
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justify || "center"};
  position: relative;
  gap: 10px;
`;

export const NotificationCounter = styled.image`
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;


